import { captureException } from '@sentry/react';

export const decodeJwt = <T = { [key: string]: any }>(token: string): T | null => {
  // handle empty strings
  if (!token) {
    return null;
  }
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map((c) => {
          return `%${(`0${c.charCodeAt(0).toString(16)}`).slice(-2)}`;
        })
        .join(''),
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    captureException(e);
    return null;
  }
};
